<!-- <object [data]="src | safe" frameborder="0" height="100%"></object> -->

<ng2-pdfjs-viewer #pdfViewer
                  [showSpinner]="false"
                  [urlValidation]="false"
></ng2-pdfjs-viewer>
